// extracted by mini-css-extract-plugin
export var wordContainer = "_lv-0";